import { render, staticRenderFns } from "./GridGroup.vue?vue&type=template&id=5fec2fc8&"
import script from "./GridGroup.vue?vue&type=script&lang=js&"
export * from "./GridGroup.vue?vue&type=script&lang=js&"
import style0 from "./GridGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports